module.exports = __webpack_public_path__ + "static/vista-7-0b5389ffa0c5b730a6d69740bf0099a9.jpeg";